import { Slot, SlotRegistry } from '@teambit/harmony';

export { Slot as Hook, SlotRegistry as HookRegistry };
